import { createSlice } from "@reduxjs/toolkit";
import { getAllActivites } from "../actions/activities";

export const activitySlice = createSlice({
  name: "rdps",
  initialState: {
    loading: false,
    activityList: [],
    totalcount: 0,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      //getAllActivites
      .addCase(getAllActivites.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAllActivites.fulfilled, (state, action) => {
        state.loading = false;
        const { result, totalDocument } = action.payload;

        state.activityList = result;
        state.totalcount = totalDocument;
      })
      .addCase(getAllActivites.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default activitySlice.reducer;